import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { Router, useNavigate } from "react-router-dom";
import IosSwitchMain from "../../../components/iosSwitchMain";
import {
  LocalizationProvider,
  DatePicker,
  DateTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface OthersFormProps {
  alignment: string;
}

function OthersForm({ alignment }: OthersFormProps) {
  const navigate = useNavigate();
  const [isSpecificDateTime, setIsSpecificDateTime] = useState(false);
  const [isAdvanceBooking, setIsAdvanceBooking] = useState(false);
  const [isCancellationEnabled, setIsCancellationEnabled] = useState(false);
  const [isGuest, setIsGuest] = useState(false);

  const [valueTabs, setValueTabs] = React.useState(0);
  const [valueTabs1, setValueTabs1] = React.useState(0);


  const [type, setType] = useState('');
  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value);
  };
  const isTypePaid = type === 'paid';

  const [value, setValue] = React.useState({
    page: "0",
    type: "0",
  });

  const handleChange1 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <div className="section_title mn_hdng">
        <h2>Others</h2>
      </div>

      <div className="gap_m avnc_bkng avnc_other_bkng">
        <div className="control_group has_border w_100">
          <div className="gap_m pb_15">
            <div className="control_group cncl_plcy w_50">
              <label>Specific Date & Time</label>
              <IosSwitchMain
                checked={isSpecificDateTime}
                onChange={(e) => setIsSpecificDateTime(e.target.checked)}
              />
            </div>
          </div>
          {isSpecificDateTime && (
            <div className="gap_m">
              <div className="control_group w_50">
                <label> Date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    slots={{
                      openPickerIcon: () => (
                        <img src="/static/images/calendar_icon.svg" alt="icon" />
                      ),
                      textField: (params) => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder="Date"
                          hiddenLabel
                        />
                      ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>
              <div className="w_50 control_group">
                <label> Time</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    className="form_control"
                    slots={{
                      openPickerIcon: () => (
                        <img src="/static/images/calendar_icon.svg" alt="icon" />
                      ),
                      textField: (params) => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder=" Time"
                          hiddenLabel
                        />
                      ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>
            </div>
          )}
        </div>
        <div className="control_group has_border w_100">
          <div className="gap_m pb_15">
            <div className="control_group cncl_plcy w_50">
              <label>Advance Booking Period</label>
              <IosSwitchMain
                checked={isAdvanceBooking}
                onChange={(e) => setIsAdvanceBooking(e.target.checked)}
              />
            </div>
          </div>
          {isAdvanceBooking && (
            <div className="gap_m">
              <div className="advnc control_group w_100">
                <TextField
                  placeholder="Booking Period"
                  hiddenLabel
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" className="size_big">
                        <Select
                          className="dropse"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          value={value.page}
                          name="page"
                          onChange={handleChange1}
                        >
                          <MenuItem value="0" disabled>
                            Select
                          </MenuItem>

                          <MenuItem value="10">Week</MenuItem>
                          <MenuItem value="20">Month</MenuItem>
                        </Select>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
          )}
        </div>
        <div className="control_group has_border w_100">
          <div className="gap_m pb_15">
            <div className="control_group cncl_plcy w_50">
              <label>Cancellation Policy</label>
              <IosSwitchMain
                checked={isCancellationEnabled}
                onChange={(e) => setIsCancellationEnabled(e.target.checked)}
              />
            </div>
          </div>
          {isCancellationEnabled && (
            <div className="gap_m">
              <div className="control_group w_50">
                <label>Cancellation Amount Per Person</label>
                <TextField
                  placeholder="Enter cancellation charges"
                  hiddenLabel
                  fullWidth
                />
              </div>
              <div className="control_group w_50">
                <label>Cancellation Hours</label>
                <TextField placeholder="Enter hours" hiddenLabel fullWidth />
              </div>
            </div>
          )}
        </div>
        <div className="control_group has_border w_100">
          <div className="gap_m pb_15">
            <div className="control_group cncl_plcy w_50">
              <label>Add Guest</label>
              <IosSwitchMain
                checked={isGuest}
                onChange={(e) => setIsGuest(e.target.checked)}
              />
            </div>
          </div>
          {isGuest && (
            <div className="gap_m">
              <div className="control_group w_50">
                <label>No. of Guests</label>
                <TextField placeholder="Enter Price" hiddenLabel fullWidth />
              </div>
              <div className="control_group w_50">
                <label>Non-Member Price</label>
                <TextField placeholder="Enter Price" hiddenLabel fullWidth />
              </div>
            </div>
          )}
        </div>
        <div className="control_group has_border w_100">
          <div className="gap_m pb_15">
            <div className="control_group w_100">
              <label>Type</label>
              <FormControl className="paid_radio">
                <RadioGroup
                  value={type}
                  onChange={handleTypeChange}
                >
                  <FormControlLabel
                    value="paid"
                    control={<Radio />}
                    label="Paid"
                  />
                  <FormControlLabel
                    value="complimentary"
                    control={<Radio />}
                    label="Complimentary"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          {isTypePaid && (
            <div className="gap_m">
              
              <div className="control_group w_100">
                <label>Member Price</label>
                <TextField placeholder="Enter Price" hiddenLabel fullWidth />
              </div>
            </div>
          )}
        </div>


        <Box className="custom_tabs2 mt_40 mb_30" sx={{ width: "100%" }}>
          <Tabs
            aria-label="basic tabs example"
            className="custom_tabs_links"
            value={valueTabs}
            onChange={(e, newValue) => setValueTabs(newValue)}
          >
            <Tab {...a11yProps(0)} label="+ Add Custom" />
            <Tab {...a11yProps(1)} label="+ Add Previous Questions" />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="control_group w_100 cstm_mn">
            <div className="gap_m">
              <div className="control_group w_50">
                <label>Select Type</label>

                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  name="type"
                  value={value.type}
                  onChange={handleChange1}
                >
                  <MenuItem value="0" disabled>
                    Select Type
                  </MenuItem>

                  <MenuItem value="10"> Checkbox</MenuItem>
                  <MenuItem value="20">Input</MenuItem>
                </Select>
              </div>

              <div className="control_group w_50">
                <label>Enter Question</label>
                <TextField placeholder="Question" hiddenLabel fullWidth />
              </div>
            </div>
          </div>

          <div className="control_group w_100">
            <label>Add Options</label>
            <TextField placeholder="Option Text" hiddenLabel fullWidth />
          </div>
          <div className="control_group w_100 chkbx_mn">
            <FormControlLabel
              control={<Checkbox />}
              name="remember"
              label="Save this question for other offers"
            />
            <Button className="btn btn_primary">+ Add Option</Button>
          </div>

          <div className="control_group w_100 prfrnc">
            <label>
              Seating preferences{" "}
              <img src="/static/images/edit_icon.svg" alt="icon" />{" "}
            </label>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="Indoor Seating"
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
              <FormControlLabel control={<Checkbox />} label="Indoor Seating" />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
            </FormGroup>
          </div>
        </CustomTabPanel>
        <div className="control_group w_100">
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="cards crds_mn">
              <Box className="custom_tabs2  mb_30" sx={{ width: "100%" }}>
                <Tabs
                  aria-label="basic tabs example"
                  className="custom_tabs_links"
                  value={valueTabs}
                  onChange={(e, newValue) => setValueTabs(newValue)}
                >
                  <Tab {...a11yProps(0)} label="Checkbox" />
                  <Tab {...a11yProps(1)} label="Text" />
                  <Tab {...a11yProps(2)} label="Radio" />
                  <Tab {...a11yProps(3)} label="Dropdown" />
                </Tabs>
              </Box>

              <CustomTabPanel value={valueTabs1} index={0}>
                <FormGroup className="prvs_qstn_mn">
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 1</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />

                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 2</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />
                </FormGroup>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs1} index={1}>
                <FormGroup className="prvs_qstn_mn">
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 1</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />

                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 2</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />
                </FormGroup>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs1} index={2}>
                <FormGroup className="prvs_qstn_mn">
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 1</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />

                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 2</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />
                </FormGroup>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs1} index={3}>
                <FormGroup className="prvs_qstn_mn">
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 1</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />

                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 2</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />
                </FormGroup>
              </CustomTabPanel>
              <div className="btn_flex flx_end">
                <Button className="btn btn_primary">Save</Button>
              </div>
            </div>
          </CustomTabPanel>
        </div>

        <div className="btn_flex flx_end">
          {alignment === "archived" && (
            <Button
              className="btn btn_primary"
              onClick={() =>
                navigate("/manage-offer")
              }
            >
              Save & Exit
            </Button>
          )}
          <Button
            className="btn btn_primary"
            onClick={() =>
              navigate("/manage-offer/preview-offer?mode=OTHERS")
            }
          >
            Preview
          </Button>
        </div>
      </div>
    </>
  );
}

export default OthersForm;
